
(function(){
  function normalized(value){return String(value||'').trim().toLowerCase();}
  function findFormatValue(root){
    var checked=root.querySelector('input[type="radio"]:checked');
    if(checked){
      var fieldset=checked.closest('fieldset');
      var legend=fieldset&&fieldset.querySelector('legend');
      if(legend&&/format|finish|product type/i.test(legend.textContent)) return checked.value;
      if(/digital|paper|canvas|frame|print/i.test(checked.value)) return checked.value;
    }
    var selects=root.querySelectorAll('select');
    for(var i=0;i<selects.length;i++){
      var label=root.querySelector('label[for="'+selects[i].id+'"]');
      if((label&&/format|finish|product type/i.test(label.textContent))||/digital|paper|canvas|frame|print/i.test(selects[i].value)) return selects[i].value;
    }
    return '';
  }
  function updateNote(note){
    var scope=note.closest('.product-info, .product-info__content, product-form, .product-main')||document;
    var value=normalized(findFormatValue(scope));
    var heading=note.querySelector('[data-mori-format-heading]');
    var copy=note.querySelector('[data-mori-format-copy]');
    if(!heading||!copy) return;
    if(value.indexOf('digital')>-1){heading.textContent='Digital download';copy.textContent=note.dataset.digitalText||'High-resolution files are delivered electronically. No physical item is shipped.';}
    else if(value){heading.textContent='Professionally printed artwork';copy.textContent=note.dataset.printText||'This physical format is produced after purchase and ships with tracking where available.';}
    else{heading.textContent='Choose your format';copy.textContent='Select digital download or a professionally printed option above.';}
  }
  function init(){
    document.querySelectorAll('[data-mori-format-note]').forEach(function(note){
      updateNote(note);
      var root=note.closest('.product-info, .product-info__content, product-form, .product-main')||document;
      root.addEventListener('change',function(){setTimeout(function(){updateNote(note)},20)});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
